export function isActiveMember(userInfo) {
  if (!userInfo) return false;

  const groupId = Number(userInfo.group_id || 0);
  const expireTime = Number(userInfo.dtime || 0);

  return groupId === 2 && expireTime * 1000 > Date.now();
}
